import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-back-arrow-button',
  templateUrl: './back-arrow-button.component.html',
  styleUrls: ['./back-arrow-button.component.scss'],
})
export class BackArrowButtonComponent {
  @Input() label: string;
  @Output() clicked: EventEmitter<void> = new EventEmitter();
}
